import type { CustomStepType } from '@shared/patient-intake-status';

import type { StepConfigFor } from '../getStepConfig.types.ts';
import { MessageStepConfig } from './MessageStepConfig.ts';
import { DocumentUploadStepConfig } from './DocumentUploadStepConfig.ts';
import { DischargeLetterUploadStepConfig } from './DischargeLetterUploadStepConfig.ts';

export const customStepsConfig: {
  [K in CustomStepType]: StepConfigFor<K>;
} = {
  DOCUMENT_UPLOAD: DocumentUploadStepConfig,
  MESSAGE: MessageStepConfig,
  DISCHARGE_LETTER_UPLOAD: DischargeLetterUploadStepConfig,
};
